import React from 'react';
import { Auth } from 'aws-amplify';
import { AppleIcon, FacebookIcon, GoogleIcon } from 'shared/components/Icons';
import { useTranslation } from 'react-i18next';
import { sendEvent } from 'utils/analyticsHelpers';
// import { AppleIcon, AmazonIcon } from 'shared/components/Icons';

const AuthConnect = ({ authType }) => {
  const { t } = useTranslation();

  const onFedereatedSignIn = async provider => {
    try {
      await Auth.federatedSignIn({ provider });
      sendEvent(authType, { method: provider });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className='social-login'>
      <div className='social-or-line'>{t('auth_connect_or')}</div>
      <button
        className='btn btn-block mb-8 mb-md-10 btn-social btn-social-google'
        onClick={() => onFedereatedSignIn('Google')}
      >
        <GoogleIcon />
        {t('auth_login_with_gmail')}
      </button>
      <button
        className='btn btn-block mb-8 mb-md-10 btn-social btn-social-facebook'
        onClick={() => onFedereatedSignIn('Facebook')}
      >
        <FacebookIcon width='24' height='24' />
        {t('auth_login_with_facebook')}
      </button>
      <button
        className='btn btn-block mb-8 mb-md-10 btn-social btn-social-apple'
        onClick={() => onFedereatedSignIn('SignInWithApple')}
      >
        <AppleIcon width='24' height='24' />
        {t('auth_login_with_apple')}
      </button>
      {/* <button
        className='btn btn-block btn-social btn-social-amazon'
        onClick={() => onFedereatedSignIn('Apple')}
      >
        <img width='24' src={AmazonIcon} alt='amazonIcon' />
        {t('auth_login_with_amazon')}
      </button> */}
    </div>
  );
};

export default AuthConnect;
